import { Params, RouterStateSnapshot } from '@angular/router';
import { RouterStateSerializer } from '@ngrx/router-store';

export interface ParamsRouterState {
  url: string;
  entity?: any;
  queryParams: Params;
}

export class ParamsSerializer implements RouterStateSerializer<ParamsRouterState> {
  public serialize(routerState: RouterStateSnapshot): ParamsRouterState {
    let route = routerState.root;
    while (route.firstChild) {
      route = route.firstChild;
    }

    const {
      url,
      root: { queryParams },
    } = routerState;
    const { params } = route;

    let state: ParamsRouterState = { url, queryParams };
    if (params.query) {
      const slug = params.query.split('-');
      const entityInfo = {
        id: slug.pop(),
        name: this.onlyNameHotel(slug),
      };
      state = {
        ...state,
        entity: entityInfo,
      };
    }
    return state;
  }

  private onlyNameHotel(slug: any) {
    let nameHotel = slug.join(' ') as string;
    if (nameHotel.includes('hoteles en ')) {
      nameHotel = nameHotel.split('hoteles en ')[1];
    }
    return nameHotel;
  }
}
